const CovidScreeningMetadataLang = {
    fr: {
        covidScreeningHealthcareInstitution: {
            dropDown: {
                0: 'Autre',
                1: 'Centre de santé Inuulitsivik',
                2: 'Centre de santé Tulattavik de l’Ungava',
                3: 'Centre hospitalier de l’Université de Montréal (CHUM)',
                4: 'CENTRE HOSPITALIER UNIVERSITAIRE SAINTE-JUSTINE',
                5: 'Centre universitaire de santé McGill (CUSM)',
                6: 'CHU de Québec - Université Laval',
                7: 'CISSS de Chaudière-Appalaches',
                8: 'CISSS de l’Abitibi-Témiscamingue',
                9: 'CISSS de l’Outaouais',
                10: 'CISSS de la Côte-Nord',
                11: 'CISSS de la Gaspésie',
                12: 'CISSS de la Montérégie-Centre',
                13: 'CISSS de la Montérégie-Est',
                14: 'CISSS de la Montérégie-Ouest',
                15: 'CISSS de Lanaudière',
                16: 'CISSS de Laval',
                17: 'CISSS des Îles',
                18: 'CISSS des Laurentides',
                19: 'CISSS du Bas-Saint-Laurent',
                20: 'CIUSSS de l’Est-de-l’Île-de-Montréal',
                21: 'CIUSSS de l’Estrie - Centre hospitalier universitaire de Sherbrooke',
                22: 'CIUSSS de l’Ouest-de-l’Île-de-Montréal',
                23: 'CIUSSS de la Capitale-Nationale',
                24: 'CIUSSS de la Mauricie-et-Centre-du-Québec',
                25: 'CIUSSS du Centre-Ouest-de-l’Île-de-Montréal',
                26: 'CIUSSS du Centre-Sud-de-l’Île-de-Montréal',
                27: 'CIUSSS du Nord-de l’Île-de-Montréal',
                28: 'CIUSSS du Saguenay–Lac-Saint-Jean',
                29: 'CLSC Naskapi',
                30: 'Conseil Cri de la santé et des services sociaux de la Baie James (CCSSSBJ)',
                31: 'CRSSS de la Baie-James',
                32: 'Institut de cardiologie de Montréal (ICM)',
                33: 'Institut national de psychiatrie légale Philippe-Pinel',
                34: 'Institut universitaire de cardiologie et de pneumologie de Québec - Université Laval',
                35: 'RRSSS du Nunavik',
                36: 'Système',
            },
        },
        covidScreeningHealthcareSharingResult: {
            description: 'Je consens à ce que le centre qui procédera à mon dépistage transmette mon résultat au bureau de santé se rattachant à l’établissement pour lequel je travaille. Si je refuse, je m’engage à transmettre mon résultat à mon employeur dès sa réception.',
            consent: 'Je consens',
            refuse: 'Je refuse',
        },
        covidScreeningHealthcareInstitutionType: {
            dropDown: {
                0: 'RI',
                1: 'RPA',
                2: 'RTF',
                3: 'CHSLD',
            },
        },
        covidScreeningConsentReceiveResultByEmailSms: {
            accept: 'J’accepte de recevoir mes résultats par courriel',
            description: '<p class="mb-4">J’ai lu la déclaration de consentement et JE CONSENS à ce que le centre de dépistage qui procédera à mon test de dépistage de la COVID-19 ou à celui de mon enfant de moins de 14 ans me transmette le résultat de test par courriel.</p>' +
                '<p class="mb-4">Je reconnais qu’en recevant le résultat de test par courriel, certaines de mes informations sortiront de la présente plateforme informatique sécurisée et pourront ne pas bénéficier des mêmes mesures de sécurité ou pourront être accessibles à d’autres personnes. Je reconnais que si mon adresse courriel est incorrect, mon résultat de test pourrait être transmis à une mauvaise adresse courriel.</p>' +
                '<p class="mb-4">En ne consentant pas à ce que le résultat de test soit transmis par courriel, je comprends que la transmission du résultat de test sera effectuée par téléphone.</p>',
        },

        covidScreeningPreferredCommunication: {
            dropDown: {
                0: 'Courriel',
                1: 'Appel téléphonique',
            },
        },
        covidScreeningCategory: {
            dropDown: {
                0: 'Étudiant',
                1: 'Travailleur',
                2: 'Enfant (0-5 ans)',
                3: 'Sans emploi',
                4: 'Retraité',
                5: 'Autre/Refuse de préciser',
            },
        },
        covidScreeningStudentSchoolRegion: {
            dropDown: {
                0: 'Abitibi-Témiscamingue',
                1: 'Bas-Saint-Laurent',
                2: 'Capitale-Nationale',
                3: 'Chaudière-Appalaches',
                4: 'Côte-Nord',
                5: 'Estrie',
                6: 'Gaspésie-Îles-de-la-Madeleine',
                7: 'Lanaudière',
                8: 'Laurentides',
                9: 'Laval',
                10: 'Mauricie-et-Centre-du-Québec',
                11: 'Montérégie',
                12: 'Montréal',
                13: 'Nord-du-Québec',
                14: 'Nunavik',
                15: 'Outaouais',
                16: 'Saguenay-Lac-Saint-Jean',
            },
        },
        covidScreeningStudentLevel: {
            dropDown: {
                0: 'Préscolaire',
                1: 'Primaire',
                2: 'Secondaire',
                3: 'Collégial',
                4: 'Universitaire',
            },
        },
        dataTable: {
            covidScreeningHealthcareWorker: 'Dep. Covid - Travailleur de la santé',
            covidScreeningHealthcareWorkerType: 'Dep. Covid - Employé (CIUSSS, CISSS, etc...)',
            covidScreeningHealthcareInstitution: 'Dep. Covid - Établissement',
            covidScreeningHealthcareInstitutionType: 'Dep. Covid - Type d\'établissement',
            covidScreeningHealthcareSharingResult: 'Dep. Covid - Consentement divulgation',
            covidScreeningConsentSharingInformations: 'Dep. Covid - Consentement partage',
            covidScreeningConsentReceiveResultByEmailSMS: 'Dep. Covid - Consentement par courriel/SMS',
            covidScreeningPreferredCommunication: 'Dep. Covid - Préférences de communication',
            covidScreeningTravelledOutsideQuebec: 'Dep. Covid - Voyage hors Québec',
            covidScreeningCountry: 'Dep. Covid - Pays',
            covidScreeningCategory: 'Dep. Covid - Catégorie',
            covidScreeningStudentSchoolRegion: 'Dep. Covid - Région scolaire',
            covidScreeningStudentLevel: 'Dep. Covid - Niveau',
            covidScreeningStudentInstitution: 'Dep. Covid - Nom de l’établissement scolaire',
            covidScreeningWorkingQuebec: 'Dep. Covid - Travaillez-vous au Québec?',
            covidScreeningEmployerName: 'Dep. Covid - Nom de l\'employeur',
            covidScreeningChildNameOfNursery: 'Dep. Covid - Nom du service de garde',
            covidScreeningOutbreakNumber: 'Dep. Covid - Numéro d’éclosion',
        },
    },
    en: {
        covidScreeningHealthcareInstitution: {
            dropDown: {
                0: 'Other',
                1: 'Centre de santé Inuulitsivik',
                2: 'Centre de santé Tulattavik de l’Ungava',
                3: 'Centre hospitalier de l’Université de Montréal (CHUM)',
                4: 'CENTRE HOSPITALIER UNIVERSITAIRE SAINTE-JUSTINE',
                5: 'Centre universitaire de santé McGill (CUSM)',
                6: 'CHU de Québec - Université Laval',
                7: 'CISSS de Chaudière-Appalaches',
                8: 'CISSS de l’Abitibi-Témiscamingue',
                9: 'CISSS de l’Outaouais',
                10: 'CISSS de la Côte-Nord',
                11: 'CISSS de la Gaspésie',
                12: 'CISSS de la Montérégie-Centre',
                13: 'CISSS de la Montérégie-Est',
                14: 'CISSS de la Montérégie-Ouest',
                15: 'CISSS de Lanaudière',
                16: 'CISSS de Laval',
                17: 'CISSS des Îles',
                18: 'CISSS des Laurentides',
                19: 'CISSS du Bas-Saint-Laurent',
                20: 'CIUSSS de l’Est-de-l’Île-de-Montréal',
                21: 'CIUSSS de l’Estrie - Centre hospitalier universitaire de Sherbrooke',
                22: 'CIUSSS de l’Ouest-de-l’Île-de-Montréal',
                23: 'CIUSSS de la Capitale-Nationale',
                24: 'CIUSSS de la Mauricie-et-Centre-du-Québec',
                25: 'CIUSSS du Centre-Ouest-de-l’Île-de-Montréal',
                26: 'CIUSSS du Centre-Sud-de-l’Île-de-Montréal',
                27: 'CIUSSS du Nord-de l’Île-de-Montréal',
                28: 'CIUSSS du Saguenay–Lac-Saint-Jean',
                29: 'CLSC Naskapi',
                30: 'Conseil Cri de la santé et des services sociaux de la Baie James (CCSSSBJ)',
                31: 'CRSSS de la Baie-James',
                32: 'Institut de cardiologie de Montréal (ICM)',
                33: 'Institut national de psychiatrie légale Philippe-Pinel',
                34: 'Institut universitaire de cardiologie et de pneumologie de Québec - Université Laval',
                35: 'RRSSS du Nunavik',
                36: 'Système',
            },
        },
        covidScreeningHealthcareSharingResult: {
            description: 'I consent to the screening test centre sharing my test result with the health office affiliated with the facility where I work. If I decline, I promise to forward my test result to my employer as soon as I receive it.',
            consent: 'I consent',
            refuse: 'I decline',
        },
        covidScreeningHealthcareInstitutionType: {
            dropDown: {
                0: 'RI',
                1: 'RPA',
                2: 'RTF',
                3: 'CHSLD',
            },
        },
        covidScreeningConsentReceiveResultByEmailSms: {
            accept: 'I agree to receive my results by email',
            description: '<p class="mb-4">I have read the declaration of consent and I CONSENT to the center that will handle my COVID-19 screening test sending me the result by email. If the information concerns my child under 14 years of age, I CONSENT to the center that will handle my child\'s COVID-19 screening test sending me the result by email.</p>' +
                '<p class="mb-4">I understand that in choosing to receive the test result by email, part of my information will leave this secure computer platform and might not benefit from the same security measures or be accessed by third parties. I acknowledge that if my email address or telephone number is wrong, my test result could be sent to the wrong email address.</p>' +
                '<p class="mb-4">By not consenting to the test result being sent by email, I understand that the transmission of the test result will be sent by telephone.</p>',
        },
        covidScreeningPreferredCommunication: {
            dropDown: {
                0: 'Email',
                1: 'Phone',
            },
        },
        covidScreeningCategory: {
            dropDown: {
                0: 'Student',
                1: 'Worker',
                2: 'Child',
                3: 'Out of job',
                4: 'Retired',
                5: 'Other/Decline to answer',
            },
        },
        covidScreeningStudentSchoolRegion: {
            dropDown: {
                0: 'Abitibi-Témiscamingue',
                1: 'Bas-Saint-Laurent',
                2: 'Capitale-Nationale',
                3: 'Chaudière-Appalaches',
                4: 'Côte-Nord',
                5: 'Estrie',
                6: 'Gaspésie-Îles-de-la-Madeleine',
                7: 'Lanaudière',
                8: 'Laurentides',
                9: 'Laval',
                10: 'Mauricie-et-Centre-du-Québec',
                11: 'Montérégie',
                12: 'Montréal',
                13: 'Nord-du-Québec',
                14: 'Nunavik',
                15: 'Outaouais',
                16: 'Saguenay-Lac-Saint-Jean',
            },
        },
        covidScreeningStudentLevel: {
            dropDown: {
                0: 'Kindergarten',
                1: 'Primary',
                2: 'Secondary',
                3: 'CEGEP',
                4: 'University',
            },
        },
        dataTable: {
            covidScreeningHealthcareWorker: 'Covid Screening - Healthcare worker',
            covidScreeningHealthcareWorkerType: 'Covid Screening - Healthcare worker type',
            covidScreeningHealthcareInstitution: 'Covid Screening - Institution',
            covidScreeningHealthcareInstitutionType: 'Covid Screening - Institution type',
            covidScreeningHealthcareSharingResult: 'Covid Screening - Consent sharing result',
            covidScreeningConsentSharingInformations: 'Covid Screening - Consent Sharing informations',
            covidScreeningConsentReceiveResultByEmailSMS: 'Covid Screening - Consent result by Email/SMS',
            covidScreeningPreferredCommunication: 'Covid Screening - Preferred communication',
            covidScreeningTravelledOutsideQuebec: 'Covid Screening - travelled outside Quebec',
            covidScreeningCountry: 'Covid Screening - Country',
            covidScreeningCategory: 'Covid Screening - Category',
            covidScreeningStudentSchoolRegion: 'Covid Screening - Student school region',
            covidScreeningStudentLevel: 'Covid Screening - Student level',
            covidScreeningStudentInstitution: 'Covid Screening - Student institution',
            covidScreeningWorkingQuebec: 'Covid Screening - Working in Quebec?',
            covidScreeningEmployerName: 'Covid Screening - Employer name',
            covidScreeningChildNameOfNursery: 'Covid Screening - Name of nursery',
            covidScreeningOutbreakNumber: 'Covid Screening - Outbreak number',
        },
    },
};

export default CovidScreeningMetadataLang;
